module.exports = __webpack_public_path__ + "fonts/barlow-v5-latin-regular.cd81898.woff";